export const Button = ({ children }) => {
     return (
          <button className='font-medium text-black dark:text-orange-50 hover:italic hover:shadow-xl hover:shadow-sky-500  w-64 text-xl bg-gradient-to-r from-blue-600 to-red-600 border-1 border-emerald-200 p-4 rounded-full'>
               {children}
          </button>
     )
}
